import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { ApiResult } from '@crema/models/Apps';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

export const optionApi = createApi({
  reducerPath: 'optionDetail.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['optionDetail'],
  endpoints: (builder) => ({
    getOptions: builder.query({
      query: ({ pageNo = 0, pageSize = DEFAULT_ROWS_PER_PAGE, templateName = '', combinationUsed }) => {
        const url = `/api/option-details?pageNo=${pageNo}&pageSize=${pageSize}&templateName=${encodeURIComponent(
          templateName,
        )}`;
        if (combinationUsed !== undefined) {
          return { url: `${url}&combinationUsed=${combinationUsed}` };
        }
        return { url: url };
      },
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        } as ApiResult;
      },
      keepUnusedDataFor: 5,
      providesTags: ['optionDetail'],
    }),
    getOptionById: builder.query({
      query: (id) => ({ url: `/api/option-details/${id}` }),
      providesTags: ['optionDetail'],
    }),
    addOption: builder.mutation({
      query: (body) => ({
        url: '/api/option-details',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['optionDetail'],
    }),
    updateOption: builder.mutation({
      query: (body) => ({
        url: `/api/option-details/${body.id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['optionDetail'],
    }),
    deleteOption: builder.mutation({
      query: (id) => ({
        url: `/api/option-details/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['optionDetail'],
    }),
  }),
});

export const {
  useAddOptionMutation,
  useDeleteOptionMutation,
  useGetOptionByIdQuery,
  useGetOptionsQuery,
  useUpdateOptionMutation,
} = optionApi;
